module.exports = __webpack_public_path__ + "img/coinbankB38.7e15149d.jpg";